import React from 'react';
import {useFormContext as useFormContextOriginal} from '../../lib/react-hook-form';
import type {FieldValues, UseFormReturn} from './types';

export function useFormContext<
  TFieldValues extends FieldValues = FieldValues,
>(): UseFormReturn<TFieldValues> | null {
  const formContext = useFormContextOriginal<TFieldValues>();

  return React.useMemo(() => {
    if (!formContext || !('__sailFormContext' in formContext)) {
      return null;
    }

    // Extract public methods
    const {trigger, subscribe, register, setFocus, ...publicMethods} =
      formContext;

    return {
      ...publicMethods,
      validate: trigger,
      field: (name, rules) => ({name, rules}),
      __internal: {
        subscribe,
        register,
        setFocus,
      },
    };
  }, [formContext]);
}
